import { Injectable } from "@angular/core";
import { InstanceModel } from "../model/instance.model";
import { ResourceService } from "./resource.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { ProcessModel } from "../model/process.model";
import { map } from "rxjs/operators";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";
import { AttributeModel } from "../main/dynamic/model/attribute.model";
import { AttributeService } from "../main/dynamic/service/attribute.service";
import { CreateInstanceModel } from "../model/create-instance.model";

@Injectable({
    providedIn: 'root'
})
export class InstanceService extends ResourceService<InstanceModel> {

    private instance: InstanceModel


    constructor(
        http: HttpClient,
        settings: GlobalSettings,
        authService: AuthenticationService,
        private attributeService: AttributeService
        ) {
            super(http, "motor/Instances", settings.motorUrl, authService)
    }

    createInstance(processModel: ProcessModel): InstanceModel {
        let defaultSteps = <InstanceModel>JSON.parse(sessionStorage.getItem("policySteps"));

        if(defaultSteps)
        {
            defaultSteps.processId = processModel.id
            return defaultSteps
        }
    }

    ApprovalUsers(instanceModel: InstanceModel): Observable<InstanceModel>{
        if(!instanceModel) {
            throwError("O processo deve ser carregado para ser executado.")
        }

        return this.patchWithComplement('ApprovalUsers', instanceModel);
    }

    duplicate(processId: string): Observable<ProcessModel> {
        return this.postWithComplement(`${processId}/Duplicate`, null)
    }

    execute(attributes?: any): Observable<ProcessModel> {
        if(!this.instance) {
            throwError("O processo deve ser carregado para ser executado.")
        }

        return this.executeById(this.instance.processId, attributes)
    }

    executeById(processId: string, attributes?: any): Observable<ProcessModel> {
       return this.postWithComplement<ProcessModel, any>(`Execute/${processId}?resultType=Full`,
         this.attributeService.copyExtraCleanForSaveAttributes(attributes))
    }

    getByIdFull(processId: string): Observable<ProcessModel> {
        return this.getWithComplement(`${processId}/Full`)
    }

    getVersion(name: string): Observable<InstanceModel> {
        return this.getWithComplement<InstanceModel>(`${this.instance.processId}/Versions/${name}`)
    }

    getFilter(processId : string, filter: string, pathFilterName: string, attributes?: AttributeModel[]): Observable<AttributeModel[]> {
      let params = new HttpParams()
        .set("filters", String(filter))
        .set("pathFilterName", String(pathFilterName))
      params = this.buildAttributeQueryParams(attributes, params);
      let query = `?${params.toString()}`

      return this.getWithComplement(`${processId}/Filters${query}`);
    }

    getFirstLevelAttributesByType(type: string, instance: InstanceModel): AttributeModel[] {
        let attributes = instance.attributes
            .filter(attr => attr.type.toLowerCase() == type.toLowerCase())

        instance.childrenSteps.forEach(child => {
            attributes = attributes.concat(this.getFirstLevelAttributesByType(type, child))
        })

        if(instance.nextStep) {
            attributes = attributes.concat(this.getFirstLevelAttributesByType(type, instance.nextStep))
        }

        return attributes
    }

    getCurrentStep(processId: string): Observable<InstanceModel> {
        return this.getWithComplement(`${processId}/CurrentStep`)
    }

    getByProcessId(processId: string): Observable<InstanceModel> {
        return this.getBy(processId)
            .pipe(
                map((instance: InstanceModel) => {
                    this.instance = instance
                    return instance
                })
            )
    }

    getInstance(processId: string): Observable<InstanceModel> {
        return this.getWithComplement('Instance/' + processId)
    }

    import(policyId: string, file: File): Observable<InstanceModel> {
        const formData: FormData = new FormData();
        formData.append('file', file);
    
        const route = `${policyId}/xls`;
    
        return this.postFormData(route, formData);
    }

    save(createInstanceModel: CreateInstanceModel): Observable<InstanceModel> {
        return this.postGeneric<InstanceModel, CreateInstanceModel>(createInstanceModel)
            .pipe(
                map((instance: InstanceModel) => {
                    this.instance = instance
                    return instance
                }
            ))
    }

    saveCurrentState(processId: string): Observable<any> {
        return this.patchWithComplement(`${processId}/Versions/Current`, {})
    }

    setCurrentStep(processId: string, stepName: string): Observable<InstanceModel> {
        return this.postWithComplement("CurrentStep", {
            "ProcessId": processId,
            "Attributes": [
                {
                    "Key": "Step",
                    "Value": stepName,
                    "Type": "text"
                }
            ]
        })
    }

    updateAttribute(attributes: AttributeModel[], processId: string): Observable<any> {
        return this.update(attributes, processId)
    }
}
